import { useStores } from "../../store/index";
import { useObserver } from "mobx-react";

const AboutSection = ({ isDownloadClicked }) => {

    const {ResumeStore} = useStores();

    return useObserver(() => (
        <div className="flex flex-col  justify-center mx-2 lg:ml-6 lg:mt-[60px]  ">
        <div className="flex flex-col  justify-center items-start md:ml-3">
            {ResumeStore.resumeBuilder?.profileSummary != "" && <h1 className="text-white text-2xl lg:text-3xl">About Me</h1>}
        </div>
        <div className="flex flex-col  justify-center items-center">
            <p className="text-white md:w-[90%] text-justify break-words pt-2 md:pt-4 text-sm lg:text-xl">{ResumeStore.resumeBuilder?.profileSummary ?? "oremnfdsbhd"}</p>
        </div>
        </div>
    ));
}

export default AboutSection;